import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import {
    message,
    Button,
    DatePicker,
    Input,
    Card,
    Typography,
} from "antd";
import { SearchOutlined, DownloadOutlined } from "@ant-design/icons";
import useAxios from "./../../CustomHooks/useAxios";
import PageLink1 from "./../PageLink/Page";
import DebounceSelect from "./../DebounceSelect";
import ShowTTSLogTable from "./ShowTTSLogTable";
import "./TTSLogs.css";

const { Text, Title } = Typography;
const dateFormat = "YYYY-MM-DD";
const dateFormat1 = "YYYY-MM-DD HH:mm";

export default function TTSLogs() {
    const { axiosi } = useAxios();
    const [messageApi, contextHolder] = message.useMessage();
    const user = useSelector((state) => state.loginReducer.user);

    const [companyid, setCompanyid] = useState({
        value: user.agents[0].company_id,
        label: user.agents[0].gmcomname,
    });
    const [sFrom, setSFrom] = useState(moment().startOf("day"));
    const [sTo, setSTo] = useState(moment().endOf("day"));
    const [refressSearch, setRefressSearch] = useState(false);
    const [page, setPage] = useState(1);
    const [data, setData] = useState();
    const [sttBegin, setSttBegin] = useState(1);
    const [stel, setStel] = useState("");
    const [sapxep, setSapxep] = useState("DESC");

    const warning = (msg) => {
        messageApi.open({
            type: "warning",
            content: msg,
        });
    };

    function onChangeSFrom(date) {
        setSFrom(date);
    }

    function onChangeSTo(date) {
        setSTo(date);
    }

    const btnSearchOnClick = () => {
        if (page === 1) {
            setRefressSearch((pre) => !pre);
        } else {
            setPage(1);
        }
    };

    const handleSearchCallLog = async () => {
        if (stel.trim().length < 3) {
            if (!sFrom) {
                warning("Vui lòng chọn [Từ ngày] !");
                return;
            }
            if (!sTo) {
                warning("Vui lòng chọn [Đến ngày] !");
                return;
            }
        }
        try {
            const timeFrom = sFrom ? sFrom.clone().startOf("day").format("YYYY-MM-DD HH:mm:ss") : "";
            const timeTo = sTo ? sTo.clone().endOf("day").format("YYYY-MM-DD HH:mm:ss") : "";

            const sdata = {
                page,
                timeFrom,
                timeTo,
                tel: stel.trim() || undefined,
                companyid: companyid?.value || undefined,
                sort: sapxep,
            };
            const kq = await axiosi.get("ttsLogs", { params: sdata });
            if (kq.status !== 204 && kq.data) {
                setData(kq.data);
                setSttBegin((kq.data.page - 1) * kq.data.pageSize + 1);
            } else {
                setData({ rows: [], page: 1, pageSize: 20, numrows: 0, pages: 0 });
            }
        } catch (error) {
            console.log("[handleSearchCallLog]:", error);
            setData({ rows: [], page: 1, pageSize: 20, numrows: 0, pages: 0 });
        }
    };

    const handleExportCallLog = async () => {
        if (!sFrom) {
            warning("Vui lòng chọn [Từ ngày] !");
            return;
        }
        if (!sTo) {
            warning("Vui lòng chọn [Đến ngày] !");
            return;
        }
        try {
            const timeFrom = sFrom ? sFrom.clone().startOf("day").format("YYYY-MM-DD HH:mm:ss") : "";
            const timeTo = sTo ? sTo.clone().endOf("day").format("YYYY-MM-DD HH:mm:ss") : "";

            const sdata = {
                pageSize: 2000,
                timeFrom,
                timeTo,
                companyid: companyid?.value || undefined,
                tel: stel.trim() || undefined,
            };
            const kq = await axiosi.get("ttsLogs/exportFile", {
                params: sdata,
                responseType: "blob",
            });
            if (kq.data && !(kq.data instanceof Blob)) {
                if (kq.data.error) {
                    warning(`Lỗi xuất file: ${kq.data.error.message || kq.data.error.name}`);
                } else if (kq.data.message) {
                    warning(`Lỗi xuất file: ${kq.data.message}`);
                } else {
                    warning("Có lỗi xảy ra khi xuất file!");
                }
                return;
            }
            const url = window.URL.createObjectURL(new Blob([kq.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `exportTTSLogs.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.log("[handleExportCallLog]:", error);
        }
    };

    async function fetchCompanyList(company_name) {
        const body = await axiosi.get("companies", {
            params: { company_name, pageSize: 100 },
        });
        if (body?.data?.rows) {
            return body?.data?.rows.map((comp) => ({
                label: comp.company_name,
                value: comp.id,
            }));
        } else {
            return [{ label: "---no data---", value: "" }];
        }
    }

    useEffect(() => {
        handleSearchCallLog();
    }, [page, refressSearch, sapxep]);

    const isAdmin = user?.agents?.[0]?.company_id === 1;

    return (
        <div className="ttslogs-container">
            {contextHolder}

            <div className="tts-header-section">
                <div>
                    <Title level={3} className="tts-title">Nhật ký TTS (Text-to-Speech)</Title>
                    <span className="tts-subtitle">Lịch sử cuộc gọi tự động và phát giọng nói nhân tạo</span>
                </div>
            </div>

            <Card className="tts-filter-card">
                <div className="filter-grid">
                    <div className="filter-field">
                        <Text className="field-label">Từ ngày</Text>
                        <DatePicker
                            onChange={onChangeSFrom}
                            value={sFrom}
                            format={dateFormat}
                            style={{ width: "100%" }}
                            placeholder="Chọn bắt đầu"
                        />
                    </div>
                    <div className="filter-field">
                        <Text className="field-label">Đến ngày</Text>
                        <DatePicker
                            onChange={onChangeSTo}
                            value={sTo}
                            format={dateFormat}
                            style={{ width: "100%" }}
                            placeholder="Chọn kết thúc"
                        />
                    </div>
                    <div className="filter-field">
                        <Text className="field-label">Số điện thoại</Text>
                        <Input
                            placeholder="Tìm kiếm theo SĐT"
                            value={stel}
                            onChange={(e) => setStel(e.target.value)}
                            allowClear
                        />
                    </div>
                    {isAdmin && (
                        <div className="filter-field">
                            <Text className="field-label">Công ty</Text>
                            <DebounceSelect
                                showSearch={true}
                                value={companyid}
                                placeholder="Chọn công ty"
                                fetchOptions={fetchCompanyList}
                                onChange={(newValue) => {
                                    setCompanyid(newValue);
                                }}
                                style={{ width: "100%" }}
                            />
                        </div>
                    )}
                </div>

                <div className="filter-actions">
                    <Button
                        type="primary"
                        icon={<SearchOutlined />}
                        onClick={btnSearchOnClick}
                    >
                        Tìm kiếm
                    </Button>
                    <Button
                        icon={<DownloadOutlined />}
                        onClick={handleExportCallLog}
                    >
                        Xuất Excel
                    </Button>
                </div>
            </Card>

            <div className="tts-table-card">
                {data ? (
                    <ShowTTSLogTable
                        data={data.rows}
                        setRefressSearch={setRefressSearch}
                        sttBegin={sttBegin}
                        sapxep={sapxep}
                        setSapxep={setSapxep}
                    />
                ) : (
                    <div style={{ padding: "40px 0", textAlign: "center" }}>Đang tải dữ liệu...</div>
                )}

                {data?.pages > 1 && (
                    <div className="tts-pagination-wrapper">
                        <PageLink1
                            pageSize={data.pageSize}
                            searchpage={"ttslogs"}
                            pages={data.pages}
                            numrows={data.numrows}
                            page={page}
                            setPage={setPage}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}